<template>
  <div class="cards">
    <!-- Próximo cobro -->
    <div class="card" :class="{ 'card--alert': o.nextCharge?.overdue }">
      <div class="card__label">Próximo cobro</div>

      <template v-if="o.trial">
        <div class="amount amount--muted">$0</div>
        <div class="card__sub">Durante el periodo de prueba</div>
      </template>
      <template v-else-if="o.nextCharge">
        <div class="amount">${{ formatMoney(o.nextCharge.amount, true) }}</div>
        <div v-if="o.nextCharge.overdue" class="overdue">Pago vencido · Contacta a Parkos para ponerte al corriente</div>
        <div v-else-if="o.nextCharge.date" class="card__sub" :class="{ 'card__sub--soon': o.nextCharge.soon }">
          <span v-if="o.nextCharge.soon" class="blink"></span>El {{ formatLongDate(o.nextCharge.date) }}
        </div>
        <div v-else class="card__sub">Sin fecha de cobro programada</div>
        <div v-if="o.requestedPlan && !o.nextCharge.overdue" class="card__note">Ya incluye tu cambio a Plan {{ o.requestedPlan.name }}</div>
      </template>
      <template v-else>
        <div class="amount amount--muted">—</div>
        <div class="card__sub">Aún no tienes cobros programados</div>
      </template>
    </div>

    <!-- Método de pago -->
    <div class="card">
      <div class="card__label">Método de pago</div>

      <template v-if="o.trial || !o.paymentMethod.lastMethod">
        <div class="method">
          <span class="mdi mdi-credit-card-off-outline method__icon"></span>
          <div class="method__text">Sin método de pago registrado</div>
        </div>
        <div class="card__sub">{{ o.trial ? 'Podrás registrar tu tarjeta antes de que termine la prueba.' : 'Tus pagos se coordinan directamente con Parkos.' }}</div>
        <button v-if="o.trial" class="link" @click="$emit('card')">Agregar tarjeta</button>
      </template>
      <template v-else>
        <div class="method">
          <span class="mdi method__icon" :class="o.paymentMethod.lastMethod === 'CARD' ? 'mdi-credit-card-outline' : 'mdi-bank-transfer'"></span>
          <div class="method__text">Pago por {{ methodName }}</div>
        </div>
        <div class="card__sub">Último pago registrado el {{ formatShortDate(o.paymentMethod.lastPaidAt) }}. Tus pagos se coordinan directamente con Parkos.</div>
        <button class="link" @click="$emit('card')">Pagar con tarjeta</button>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatLongDate, formatShortDate, formatMoney, METHOD_LABEL } from './planFormat'

const props = defineProps({ overview: { type: Object, required: true } })
defineEmits(['card'])
const o = computed(() => props.overview)
const methodName = computed(() => (METHOD_LABEL[o.value.paymentMethod.lastMethod] || 'otro medio').toLowerCase())
</script>

<style scoped>
.cards { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.card { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; padding: 16px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; box-sizing: border-box; min-width: 0; }
.card--alert { background: #fff5f5; border-color: #fecaca; }
.card__label { font: 500 11px var(--font-body); color: #64748b; text-transform: uppercase; letter-spacing: 0.04em; }
.amount { font: 700 20px var(--font-mono); color: #1e3a5f; }
.amount--muted { color: #94a3b8; }
.card__sub { display: flex; align-items: center; gap: 6px; font: 400 12px/1.45 var(--font-body); color: #64748b; }
.card__sub--soon { color: #b45309; font-weight: 500; }
.card__note { font: 400 11px var(--font-body); color: #3b82f6; }
.overdue { font: 500 12px/1.45 var(--font-body); color: #b91c1c; }
.blink { width: 6px; height: 6px; border-radius: 50%; background: #f0a500; animation: blink 1.4s ease-in-out infinite; flex-shrink: 0; }
@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }
.method { display: flex; align-items: center; gap: 10px; }
.method__icon { font-size: 24px; color: #64748b; }
.method__text { font: 500 14px var(--font-body); color: #1e3a5f; }
.link { margin-top: auto; padding: 0; background: none; border: none; cursor: pointer; font: 400 12px var(--font-body); color: #3b82f6; }
.link:hover { color: #2563eb; text-decoration: underline; }
@media (max-width: 640px) { .cards { grid-template-columns: 1fr; } }
</style>